// extracted by mini-css-extract-plugin
export default {"root":"FallbackLandingPage_root__wcP1s","content":"FallbackLandingPage_content__SS8Vn"};